var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#057E9D",
    d: "M944,459.7L510,25.4C489.5,5,456.4,5,436,25.4c-20.6,20.5-20.5,53.8,0,74.3l400.3,400.4L435.7,900.6c-20.4,20.5-20.5,53.6,0,74.1c20.5,20.5,53.6,20.5,74.1,0l434.1-433.9c11.3-11.2,15.8-26,14.9-40.6C959.8,485.6,955.2,470.9,944,459.7L944,459.7z M579.4,500c1.1-14.5-3.6-29.2-14.6-40.5L130.8,25.3c-20.5-20.4-53.6-20.4-74.2,0c-20.5,20.4-20.3,53.7-0.1,74.2l400.6,400.6L56.4,900.5C36.1,921,35.8,954,56.3,974.6c20.7,20.5,53.7,20.4,74.3,0l434.1-433.9C575.8,529.5,580.5,514.7,579.4,500L579.4,500z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.cb5cfcae.svg";
export { ForwardRef as ReactComponent };